<template>
  <b-modal
    id="modalAdd"
    ref="my-modal"
    title="เพิ่มข้อมูลโครงการ"
    size="lg"
    :ok-title="isSubmitting ? 'กำลังบันทึก...' : 'ตกลง'"
    :cancel-title="isSubmitting ? 'รอสักครู่...' : 'ยกเลิก'"
    :ok-disabled="isSubmitting"
    :cancel-disabled="isSubmitting"
    @show="genCodePJ"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <!-- Loading Overlay -->
    <div
      v-if="isSubmitting"
      class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
      style="background: rgba(255,255,255,0.8); top: 0; left: 0; z-index: 1050;"
    >
      <div class="text-center">
        <b-spinner variant="primary" />
        <p class="mt-2 mb-0">
          กำลังบันทึกข้อมูล...
        </p>
      </div>
    </div>

    <validation-observer ref="simpleRules">
      <b-row>
        <b-col lg="12">
          <b-form-group
            label="ชื่อโครงการ"
            label-for="pjname"
          >
            <validation-provider
              #default="{ errors }"
              name="Project Name"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="pj_name"
                  v-model="addData.pj_name"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="ชื่อโครงการ"
                  :disabled="isSubmitting"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          v-show="userData.groupname === 'mst' || userData.groupname === 'ftd' || userData.role === 'admin'"
          lg="3"
        >
          <b-form-group
            label="รหัสโครงการ"
            label-for="pj_code"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="pjcode"
                v-model="addData.pj_code"
                type="text"
                placeholder="รหัสโครงการ"
                :disabled="isSubmitting"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col lg="3">
          <b-form-group
            label="เลขที่สัญญา"
            label-for="contract_no"
          >
            <validation-provider
              #default="{ errors }"
              name="Contract No"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="contractno"
                  v-model="addData.contract_no"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="เลขที่สัญญา"
                  :disabled="isSubmitting"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col lg="6">
          <b-form-group
            label="หน่วยงานที่รับผิดชอบ"
            label-for="department"
          >
            <validation-provider
              #default="{ errors }"
              name="Department"
              rules="required"
            >
              <v-select
                v-model="selectDepartment"
                :reduce="department => department"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="deptname"
                :options="department"
                placeholder="เลือกหน่วยงาน..."
                transition=""
                :disabled="isSubmitting"
                @input="addDepartment()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col lg="4">
          <b-form-group
            label="สายทาง"
            label-for="road_id"
          >
            <validation-provider
              #default="{ errors }"
              name="Road"
              rules="required"
            >
              <v-select
                v-model="selectRoad"
                :reduce="road => road"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="wayid"
                :options="road"
                placeholder="เลือกสายทาง..."
                transition=""
                :disabled="isSubmitting"
                @input="addRoad()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          v-if="userData.role === 'admin'"
          lg="6"
        >
          <b-form-group
            label="ผู้รับจ้าง"
            label-for="vendor_name"
          >
            <validation-provider
              #default="{ errors }"
              name="Vendor"
              rules="required"
            >
              <v-select
                v-model="selectVendor"
                :reduce="vendor => vendor"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="vendor_name"
                :options="vendor"
                placeholder="เลือกผู้รับจ้าง..."
                transition=""
                :disabled="isSubmitting"
                @input="addVendor()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col lg="3">
          <b-form-group
            label="วันที่รับประกัน"
            label-for="guarantee date start"
          >
            <validation-provider
              #default="{ errors }"
              name="guarantee date start"
              rules="required"
            >
              <b-form-datepicker
                id="guarantee_date_start"
                v-model="date.guarantee_date_start"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                class="mb-2"
                :disabled="isSubmitting"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col lg="3">
          <b-form-group
            label="วันสิ้นสุดค้ำประกัน"
            label-for="guarantee date end"
          >
            <validation-provider
              #default="{ errors }"
              name="guarantee date end"
              rules="required"
            >
              <b-form-datepicker
                id="guarantee-date-end"
                v-model="date.guarantee_date_end"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                class="mb-2"
                :disabled="isSubmitting"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

      </b-row>
    </validation-observer>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        :disabled="isSubmitting"
        @click="cancel()"
      >
        {{ isSubmitting ? 'รอสักครู่...' : 'ยกเลิก' }}
      </b-button>
      <b-button
        variant="primary"
        :disabled="isSubmitting"
        @click="ok()"
      >
        <b-spinner
          v-if="isSubmitting"
          small
        />
        {{ isSubmitting ? 'กำลังบันทึก...' : 'ตกลง' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BInputGroup, BFormInput, BFormDatepicker,
  BSpinner, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

// Configure axios timeout
axios.defaults.timeout = 30000

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BSpinner,
    BButton,
  },
  data() {
    return {
      isSubmitting: false,
      isLoading: false,
      userData: JSON.parse(localStorage.getItem('userData')),
      required,
      department: [],
      selectDepartment: [],
      selectRoad: [],
      selectVendor: [],
      vendor: [],
      road: [],
      date: {
        guarantee_date_start: '',
        guarantee_date_end: '',
      },
      addData: {
        pj_name: '',
        contract_no: '',
        deptid: '',
        guarantee_date_start: '',
        guarantee_date_end: '',
        guarantee_year: 0,
        pj_code: '',
        deptname: '',
        groupname: '',
        road_id: '',
        road_name: '',
        vendor_id: '',
        vendor_shortname: '',
      },
    }
  },
  mounted() {
    this.initializeData()
  },

  beforeDestroy() {
    // Clear any pending requests or timers if necessary
    if (this.isSubmitting) {
      // Optional: Cancel any pending requests
      // axios.CancelToken.source().cancel()
    }
  },
  methods: {
    async initializeData() {
      try {
        this.isLoading = true
        await Promise.all([
          this.setToday(),
          this.dropdownDepartment(),
          this.dropdownVendor(),
          this.dropdownRoad(),
        ])
      } catch (error) {
        console.error('Error initializing data:', error)
        this.showError('ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง')
      } finally {
        this.isLoading = false
      }
    },

    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const date = (`0${p.getDate()}`).slice(-2)
      const year = p.getFullYear() + 2
      const yearContract = p.getFullYear()
      this.date.guarantee_date_end = `${year}-${month}-${date}`
      this.date.guarantee_date_start = `${yearContract}-${month}-${date}`
    },

    resetModal() {
      Object.assign(this.addData, {
        pj_name: '',
        contract_no: '',
        deptid: '',
        guarantee_date_start: '',
        guarantee_date_end: '',
        guarantee_year: '',
        pj_code: '',
        deptname: '',
        road_id: '',
        road_name: '',
        vendor_id: '',
        vendor_shortname: '',
      })
      this.selectDepartment = []
      this.selectVendor = []
      this.selectRoad = []
      this.isSubmitting = false
    },

    validateFormData() {
      if (!this.addData.pj_name || !this.addData.contract_no) {
        this.showError('กรุณากรอกข้อมูลให้ครบถ้วน')
        return false
      }
      return true
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()

      if (!navigator.onLine) {
        this.showError('กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต')
        return
      }

      try {
        const isValid = await this.$refs.simpleRules.validate()
        if (!isValid || !this.validateFormData()) {
          return
        }
        await this.addInfo()
        this.$nextTick(() => {
          this.$bvModal.hide('modalAdd')
        })
      } catch (error) {
        console.error('Validation error:', error)
        this.showError('เกิดข้อผิดพลาดในการตรวจสอบข้อมูล')
      }
    },

    getYearDiff(date1, date2) {
      this.addData.guarantee_year = Math.abs(date2.getFullYear() - date1.getFullYear())
    },

    async addInfo() {
      try {
        this.isSubmitting = true

        this.addData.guarantee_date_end = this.date.guarantee_date_end
        this.addData.guarantee_date_start = this.date.guarantee_date_start
        this.addData.groupname = this.userData.groupname

        await axios.post('/addProject', this.addData)

        this.$swal({
          icon: 'success',
          title: '<span style="color:#000000">เพิ่มโครงการเรียบร้อย</span>',
          showConfirmButton: false,
          timer: 1500,
        })

        this.$emit('fetch')
        this.resetModal()
      } catch (error) {
        console.error('Error adding project:', error)
        const errorMessage = error.response?.data?.message || 'เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง'
        this.showError(errorMessage)
        throw error
      } finally {
        this.isSubmitting = false
      }
    },

    async genCodePJ() {
      this.setToday()
      try {
        const response = await axios.post('/genProjectCode', {
          vendor_id: this.userData.vendor_id,
          groupname: this.userData.groupname,
        })
        this.addData.pj_code = response.data.new_pj_code
        this.addData.vendor_id = this.userData.vendor_id
        this.addData.vendor_shortname = this.userData.groupname
      } catch (error) {
        console.error('Error generating project code:', error)
        this.showError('ไม่สามารถสร้างรหัสโครงการได้ กรุณาลองใหม่อีกครั้ง')
      }
    },

    async dropdownDepartment() {
      try {
        const response = await axios.post('/dropdownDepartment')
        this.department = response.data
      } catch (error) {
        console.error('Error loading departments:', error)
        this.showError('ไม่สามารถโหลดข้อมูลหน่วยงานได้')
      }
    },

    async dropdownVendor() {
      try {
        const response = await axios.post('/dropdownVendor')
        this.vendor = response.data
      } catch (error) {
        console.error('Error loading vendors:', error)
        this.showError('ไม่สามารถโหลดข้อมูลผู้รับจ้างได้')
      }
    },

    async dropdownRoad() {
      try {
        const response = await axios.post('/dropdownRoad')
        this.road = response.data
      } catch (error) {
        console.error('Error loading roads:', error)
        this.showError('ไม่สามารถโหลดข้อมูลสายทางได้')
      }
    },

    addDepartment() {
      if (!this.selectDepartment) return
      this.addData.deptid = this.selectDepartment.DeptID
      this.addData.deptname = this.selectDepartment.deptname
    },

    addRoad() {
      if (!this.selectRoad) return
      this.addData.road_id = this.selectRoad.id
      this.addData.road_name = this.selectRoad.wayid
    },

    addVendor() {
      if (!this.selectVendor) return
      this.addData.vendor_id = this.selectVendor.vendor_id
      this.addData.vendor_shortname = this.selectVendor.vendor_shortname
    },

    showError(message) {
      this.$swal({
        icon: 'error',
        text: message,
        showConfirmButton: true,
        confirmButtonText: 'ตกลง',
      })
    },

    // Utility method to check if all required fields are filled
    checkRequiredFields() {
      const requiredFields = [
        'pj_name',
        'contract_no',
        'deptid',
        'road_id',
      ]

      return requiredFields.every(field => {
        const value = this.addData[field]
        return value !== null && value !== undefined && value !== ''
      })
    },

    // Method to handle network errors
    handleNetworkError(error) {
      if (!navigator.onLine) {
        this.showError('ไม่สามารถเชื่อมต่ออินเทอร์เน็ตได้ กรุณาตรวจสอบการเชื่อมต่อ')
        return
      }

      if (error.code === 'ECONNABORTED') {
        this.showError('การเชื่อมต่อใช้เวลานานเกินไป กรุณาลองใหม่อีกครั้ง')
        return
      }

      if (error.response) {
        // Server responded with error
        const { status } = error.response
        switch (status) {
          case 400:
            this.showError('ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลที่กรอก')
            break
          case 401:
            this.showError('กรุณาเข้าสู่ระบบใหม่')
            // Optional: Redirect to login
            break
          case 403:
            this.showError('คุณไม่มีสิทธิ์ดำเนินการนี้')
            break
          case 404:
            this.showError('ไม่พบข้อมูลที่ต้องการ')
            break
          case 500:
            this.showError('เกิดข้อผิดพลาดจากระบบ กรุณาลองใหม่ภายหลัง')
            break
          default:
            this.showError('เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ กรุณาลองใหม่อีกครั้ง')
        }
      } else {
        // Network error or other issues
        this.showError('เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง')
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to { transform: rotate(360deg); }
}

// Disable pointer events while submitting
.submitting {
  pointer-events: none;
  opacity: 0.7;
}

// Enhance form validation styles
.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
</style>
